import { parseApiUrl, storeMixin, storeGenerator, handleError } from '@/storeMixin'
import { merge } from 'lodash'
import { axiosThux } from '@/axiosThux'

const teamrole = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/account/{profile}/team-role',
    app: 'account'
  },
  actions: {
    async getSections ({ state, commit, dispatch }) {
      const url = `${parseApiUrl(this, state.apiUrl)}/sections/`
      return axiosThux.get(url)
        .then(
          response => {
            return response.data
          }
        ).catch(error => {
          handleError(commit, dispatch, error)
        })
    }
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'account', model: 'teamrole' }
    ),
    {
      GENERIC: {
        account: {
          teamrole: {
            DETAIL: {
              ACTIONS: {
                getSections: 'GENERIC/account/teamrole/getSections'
              }
            }
          }
        }
      }
    }
  )
)()

export { teamrole, TYPES }
